export default {
  name: 'accordion-tab',
  data: () => ({
    expanded: false
  }),
  props: {
    startExpanded: {
      type: Boolean,
      default: false
    },
  },
  mounted() {
    if (this.startExpanded) {
      this.expanded = true
    }
  },
  computed: {
    scope() {
      return {
        toggleTab: this.toggleTab,
        expanded: this.expanded
      }
    }
  },
  methods: {
    toggleTab() {
      this.expanded = !this.expanded
      this.$emit('tabToggled', this.expanded)
    },
    closeTab() {
      this.expanded = false
    }
  },
  render() {
    return this.$scopedSlots.default(this.scope)
  }
}
